<section class="legend-list">
  <app-row gutter="y-md">
    <ng-container *ngFor="let dataPoint of chartData; let i = index">
      <app-col [md]="columns" xs="12">
        <div class="legend-list__item" (click)="chartToggleClick(i)">
          <div class="legend-list__item-label mr-2" [style.background-color]="dataPoint.backgroundColor"></div>

          <div class="legend-list__item-content">
            <p class="legend-list__item-content-suffix" [ngClass]="{'removed': clickedIndexes.includes(i)}">
            {{
              showLastPoint ? lastPoint(dataPoint.data) : calculateTotal(dataPoint.data)
            }}
              <span
                *ngIf="dataPoint.label === 'Not Fulfilled'"
                [matTooltip]="'dashboard.NotFulfilledDescription' | translate"
                matTooltipPosition="above"
              >
                <img class="reset-spacing" src="assets/images/icons/message-question.svg"/>
              </span>
            </p>

            <span class="legend-list__item-content-prefix">{{ dataPoint.label }}</span>
          </div>
        </div>
      </app-col>
    </ng-container>
  </app-row>
</section>
